import classNames from "classnames";
import { Icon } from "PFComponents/icon";
import React, { SyntheticEvent } from "react";

import css from "./table_properties_button.module.scss";

type TablePropertiesButtonProps = {
  isActive: boolean;
  onClick: (e: SyntheticEvent) => void;
  style?: React.CSSProperties;
};

const TablePropertiesButton = ({ isActive, onClick, style }: TablePropertiesButtonProps) => (
  <div className={css.root} style={style}>
    <button
      className={classNames(css.tableIcon, {
        [css.activeButton]: isActive
      })}
      onClick={onClick}
      id="table_properties_button"
      data-qa-id="WorkflowPageTablePropertiesButton"
    >
      <Icon name="table" size="sm" />
    </button>
  </div>
);

export default TablePropertiesButton;
